module.exports = __webpack_public_path__ + "img/friends-lopatari-sm.ce81db10.png";